import CommonAttributeSvg from "@assets/icons/common-attribute.svg";
import { useSwitches } from "@hooks/useSwitches";
import { Tooltip } from "@ui/Tooltip";

const TOOLTIP_TEXT_DEFAULT =
  "Common attribute shared between Company and active Deal. Changes apply to both.";
const TOOLTIP_TEXT_MULTIPLE_ACTIVE_DEALS =
  "Common attribute shared between Company and primary active Deal. Changes apply to both.";

interface CommonAttributeIconProps {
  // Renders the icon as a button linking to the shared deal; plain icon when omitted.
  onClick?: () => void;
}

export function CommonAttributeIcon({ onClick }: CommonAttributeIconProps) {
  const { isAvailable } = useSwitches();
  const tooltipText = isAvailable("MULTIPLE_ACTIVE_DEALS")
    ? TOOLTIP_TEXT_MULTIPLE_ACTIVE_DEALS
    : TOOLTIP_TEXT_DEFAULT;

  return (
    <Tooltip
      placement="bottom"
      variant="dark"
      arrow
      tooltipContent={tooltipText}
      tooltipContentClassName="max-w-[240px] text-left text-[13px]"
      delay={{ open: 500, close: 200 }}
      className="flex shrink-0 items-center"
    >
      {onClick ? (
        <button
          type="button"
          data-testid="common-attribute-icon"
          aria-label="Go to shared deal attribute"
          className="flex items-center text-emerald-600 transition-opacity hover:opacity-70"
          onClick={onClick}
        >
          <CommonAttributeSvg className="h-3.5 w-3.5" />
        </button>
      ) : (
        <span data-testid="common-attribute-icon" className="flex items-center">
          <CommonAttributeSvg className="h-3.5 w-3.5 text-emerald-600" />
        </span>
      )}
    </Tooltip>
  );
}
